import { PropType, Ref, defineComponent, inject, onMounted, ref, watch, h, computed } from 'vue';
import {
  NAffix,
  NButton,
  NNotificationProvider,
  createDiscreteApi,
  darkTheme,
  lightTheme,
} from 'naive-ui';

import type { ConfigProviderProps } from 'naive-ui';
import SVG from '@dts/shared/src/assets/svg';
import HorizontalMenu from './components/HorizontalMenu';
import styles from './index.module.scss';
import Search from './components/Search';
import Expand from './components/Expand';
import User from './components/User';
import { useRouter } from 'vue-router';
import { genStaticUrl } from '@dts/shared/src/utils/httpUrlConfig';
import { StepsID } from '@/view/Home/HomePage/components/TourSteps';
import NotifyTitle from '@/components/Notify/title';
import NotifyMessage from '@/components/Notify/message';
import { timestampToTime } from '@/utils/baseTool';

const props = {
  listenTo: {
    type: Function as PropType<() => HTMLElement>,
    default: () => {},
  },
};
const themeRef = ref<'light' | 'dark'>('light');
const configProviderPropsRef = computed<ConfigProviderProps>(() => ({
  theme: themeRef.value === 'light' ? lightTheme : darkTheme,
}));
const { notification } = createDiscreteApi(['message', 'dialog', 'notification', 'loadingBar'], {
  configProviderProps: configProviderPropsRef,
});
const Header = defineComponent({
  setup: (props) => {
    const router = useRouter();

    const globalScrollTop = inject<any>('globalScrollTop');
    const navBarStyle = ref(styles.headerMenu);

    const computedTime = (time: any) => {
      return time * 60 * 1000;
    };

    const polltime = computedTime(5);
    const handleDirHome = () => {
      router.push({
        path: '/home',
      });
    };
    const getNotify = async () => {
      try {
        const res = await $dts.dtsNotification.pushWhenOnline.request({}, {});
        if (res.data?.length) {
          createNotify(res.data[0]);
        }
      } catch (err) {
        console.error(err);
      }

      setTimeout(getNotify, polltime);
    };
    const clickGotit = async (val: any) => {
      try {
        await $dts.dtsUser.onReadNote.request(
          {
            id: val,
          },
          {},
        );
      } catch (err) {
        console.error('clickGotit', err);
      }
    };
    const createNotify = (item: any) => {
      const n = notification.create({
        title: () =>
          h(NotifyTitle, {
            notification: item,
          }),
        content: () =>
          h(NotifyMessage, {
            notification: item,
          }),
        meta: () =>
          h(
            'div',
            {
              style: {
                fontFamily: 'BMWTypeNext',
                fontSize: '0.16rem',
                fontWeight: '300',
              },
            },
            ` ${timestampToTime(item.releaseTime, 'time')} `,
          ),

        action: () =>
          h(
            NButton,
            {
              text: true,
              type: 'primary',
              onClick: () => {
                n.destroy();
                clickGotit(item.id);
              },
            },
            {
              default: () =>
                h(
                  'div',
                  {
                    style: {
                      fontFamily: 'BMWTypeNext',
                      fontSize: '0.16rem',
                      fontWeight: '400',
                      color: '#80c21b',
                    },
                  },
                  'Got it',
                ),
            },
          ),
        keepAliveOnHover: true,
      });
    };
    onMounted(() => {
      //5s 后在调用，防止与登录消息重合
      setTimeout(getNotify, 5000);
    });

    watch(globalScrollTop, (scrollTop) => {
      if (scrollTop > 25) {
        navBarStyle.value = styles.headerMenuOffTop;
      } else {
        navBarStyle.value = styles.headerMenu;
      }
    });

    return () => (
      <>
        <NNotificationProvider>
          <NAffix
            class={styles.menuFixed}
            top={0}
            listenTo={props.listenTo}
            style={{ zIndex: 999 }}
          >
            <div class={navBarStyle.value}>
              <div id={StepsID.stepBar}>
                <HorizontalMenu />
              </div>
              <Search />
              <User />
              <div>
                <Expand />
              </div>
            </div>
          </NAffix>

          <div class={styles.header}>
            <div class={styles.headerLeft}>
              <div class={styles.icon} onKeypress={() => {}} onClick={handleDirHome}>
                <SVG.BMWAndMiniAndRollsRoyceIcon />
              </div>
            </div>
            <div class={styles.headerRight}>
              <img
                class={styles.img}
                src={genStaticUrl('eraImages/dts-logo.png')}
                onKeypress={() => {}}
                onClick={handleDirHome}
                alt="dts-logo"
              />
            </div>
          </div>
        </NNotificationProvider>
      </>
    );
  },
  props,
});
export default Header;
